import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { CoreUIToastConfig } from '../services/toast.service';

@Injectable({
    providedIn: 'root',
})
export class AppEventsService {

    private loaderSubject = new BehaviorSubject<LoaderEvent>({
        visible: false,
        trace: '[init]',
    });

    loader(): Observable<LoaderEvent> {
        return this.loaderSubject.asObservable();
    }
    loaderVisiblePublish(visible: boolean, trace: string) {
        queueMicrotask(() => {
            this.loaderSubject.next({ visible, trace });
        });
    }

    // ─────────────────────────── TOASTS ───────────────────────────
    private toastInfoSubject = new Subject<ToastEvent>();
    private toastSuccessSubject = new Subject<ToastEvent>();
    private toastWarningSubject = new Subject<ToastEvent>();
    private toastErrorSubject = new Subject<ToastEvent>();

    toastInfo(): Observable<ToastEvent> {
        return this.toastInfoSubject.asObservable();
    }

    toastSuccess(): Observable<ToastEvent> {
        return this.toastSuccessSubject.asObservable();
    }

    toastWarning(): Observable<ToastEvent> {
        return this.toastWarningSubject.asObservable();
    }

    toastError(): Observable<ToastEvent> {
        return this.toastErrorSubject.asObservable();
    }

    toastInfoOpenPublish(config: CoreUIToastConfig, trace: string) {
        this.toastInfoSubject.next({ config, trace });
    }

    toastSuccessOpenPublish(config: CoreUIToastConfig, trace: string) {
        this.toastSuccessSubject.next({ config, trace });
    }

    toastWarningOpenPublish(config: CoreUIToastConfig, trace: string) {
        this.toastWarningSubject.next({ config, trace });
    }

    toastErrorOpenPublish(config: CoreUIToastConfig, trace: string) {
        this.toastErrorSubject.next({ config, trace });
    }

    // ─────────────────────────── DIALOG ───────────────────────────
    private dialogPayoutSubject = new Subject<DialogPayoutEvent>();

    dialogPayout(): Observable<DialogPayoutEvent> {
        return this.dialogPayoutSubject.asObservable();
    }

    dialogPayoutOpenPublish(trace: string) {
        this.dialogPayoutSubject.next({ trace });
    }
}


// ─────────────────────────── TIPOS ───────────────────────────

export interface LoaderEvent {
    visible: boolean;
    trace: string;
}

export interface ToastEvent {
    config: CoreUIToastConfig;
    trace: string;
}

export interface DialogPayoutEvent {
    trace: string;
}
